import {createRouter, createWebHistory} from 'vue-router'
import AuthIndex from '../layouts/AuthLayout.vue'
import Auth from '../views/auth/Auth.vue'
import Register from '../views/auth/Register.vue'
import LogIn from '../views/auth/LogIn.vue'
import HomeDefault from '../components/HomeDefault.vue'
import Home from '@/views/Home.vue'
import History from '@/views/History.vue'
import OnDatoResult from '@/views/OnDatoResult.vue'
import Wallet from '@/views/wallet/Wallet.vue'
import WalletSave from '@/views/wallet/WalletSave.vue'
import WalletTopUp from '@/views/wallet/WalletTopUp.vue'
import WalletPaymentsFinish from '@/views/wallet/WalletPaymentsFinish.vue'
import WalletWithdrawal from '@/views/wallet/WalletWithdrawal.vue'
import WalletWithdrawalTransaction from '@/views/wallet/WalletWithdrawalTransaction.vue'
import WalletId from '@/views/wallet/WalletId.vue'
import Payment from '@/views/Payment.vue'
import Settings from '@/views/Settings.vue'
import Exchange from '@/views/exchange/Index.vue'
import ExchangeConfirm from '@/views/exchange/Confirm.vue'
import ExchangeTransaction from '@/views/exchange/Transaction.vue'
import Cards from '@/views/cards/CardsMain.vue'
import CardPage from '@/views/cards/CardPage/CardPageMain.vue'
import NewCardPage from '@/views/cards/CardPage/NewCardPage/NewPageMain.vue'
import VerificationCardPage from '@/views/cards/CardPage/Verification/VerificationCardPage.vue'
import ReplenishmentCardPage from '@/views/cards/CardPage/Replenishment/ReplenishmentCardPage.vue'
import EnvPage from '../views/debug/EnvPage.vue'
import LoginAs from '../views/auth/LoginAs.vue'
import {settings} from '../appType/settings.js'

const routes = [
  {
    path: '/',
    name: "Registered",
    component: HomeDefault,
    children: [
      {path: '/', name: "Home", component: Home},
      {path: 'ondato/result', name: "OnDatoResult", component: OnDatoResult},
      {path: 'history', name: "History", component: History},
      {path: 'wallet', name: "Wallet", component: Wallet},
      {path: 'wallet/:id', name: "WalletId", component: WalletId},
      {path: 'wallet/payments/finish', name: "WalletPaymentsFinish", component: WalletPaymentsFinish},
      {path: 'wallet/topup', name: "WalletTopUp", component: WalletTopUp},
      {path: 'wallet/topup/transaction/:id', name: "WalletTopUpTransaction", component: WalletTopUp},
      {path: 'wallet/withdrawal', name: "WalletWithdrawal", component: WalletWithdrawal},
      {path: 'wallet/withdrawal/transaction/:id', name: "WalletWithdrawalTransaction", component: WalletWithdrawalTransaction},
      {path: 'wallet/save', name: "WalletSave", component: WalletSave},
      {path: 'payment', name: "Payment", component: Payment},
      {path: 'settings', name: "Settings", component: Settings},
      {path: 'exchange', name: "Exchange", component: Exchange},
      {path: 'exchange/confirm', name: "ExchangeConfirm", component: ExchangeConfirm},
      {path: 'exchange/transaction/:id', name: "ExchangeTransaction", component: ExchangeTransaction},
      {path: 'cards', name: "Cards", component: Cards},
      {path: 'card/:id', name: "CardPage", component: CardPage},
      {path: 'card/:id/verification', name: "VerificationCardPage", component: VerificationCardPage},
      {path: 'card/:id/replenishment', name: "ReplenishmentCardPage", component: ReplenishmentCardPage},
      {path: 'card/new', name: "NewCardPage", component: NewCardPage},
    ]
  },
  {
    path: '/auth',
    name: 'Auth',
    component: AuthIndex,
    children: [
      {path: '', name: "AuthIn", component: Auth},
      {path: 'login', name: "LogIn", component: LogIn},
      {path: 'register', name: "Register", component: Register},
      {path: 'login-as', name: "LoginAs", component: LoginAs}
    ]
  }
]

if (settings.env.VUE_APP_ENV === 'development') {
  routes.push({
    path: '/env',
    name: "Env",
    component: EnvPage,
  })
}

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
